export default "__VITE_ASSET__BreKMJoH__"